import MaterialComponent from "../components/materialComponent";
import WorkplanComponent from "../components/workplanComponent";
import WorkplaceComponent from "../components/workplaceComponent";
import OrderComponent from "../components/orderComponent";
import FertigerComponent from "../components/fertigerComponent";
import EditFertigerComponent from "../components/editFertigerComponent";
import LogComponent from "../components/logComponent";
import TicketComponent from "../components/ticketComponent";
import TicketDetailComponent from "../components/ticketDetailComponent.vue";
import ProductionComponent from "../components/productionComponent";
import CapacityComponent from "../components/capacityComponent";
import ToolsComponent from "../components/toolsComponent";
import PressJoinsComponent from "../components/pressJoinsComponent";
import OrderCancellationComponent from "../components/orderCancellationComponent";
import ReportComponent from "../components/reportComponent";
import LeergutComponent from "../components/leergutComponent";
import OrderTapeComponent from "../components/orderTapeComponent";
import PlanningComponent from "../components/planningComponent";
import CertificateComponent from "../components/certificateComponent.vue";
import OffersComponent from "../components/offersComponent.vue";
import OfferComponent from "../components/offerComponent.vue";
import ManufacturerOverviewComponent from "../components/manufacturerOverviewComponent.vue";

export const routes = [
	{
		name: "fertiger",
		path: "/fertiger",
		component: FertigerComponent,
	},
	{
		name: "editFertiger",
		path: "/:fertigerId/edit",
		props: true,
		component: EditFertigerComponent,
	},
	{
		name: "capacity",
		path: "/capacity",
		component: CapacityComponent,
	},
	{
		name: "manufacturingOverview",
		path: "/manufacturing-overview",
		component: ManufacturerOverviewComponent,
	},
	{
		name: "order",
		path: "/:fertigerId/order",
		component: OrderComponent,
	},
	{
		name: "orderCancellation",
		path: "/:fertigerId/cancellation/:orderId",
		component: OrderCancellationComponent,
	},
	{
		name: "material",
		path: "/:fertigerId/material",
		component: MaterialComponent,
	},
	{
		name: "workplans",
		path: "/:fertigerId/workplans",
		component: WorkplanComponent,
	},
	{
		name: "workplaces",
		path: "/:fertigerId/workplaces",
		component: WorkplaceComponent,
	},
	{
		name: "tools",
		path: "/:fertigerId/tools",
		component: ToolsComponent,
	},
	{
		name: "pressJoins",
		path: "/:fertigerId/pressJoins",
		component: PressJoinsComponent,
	},
	{
		name: "tickets",
		path: "/:fertigerId/tickets",
		component: TicketComponent,
	},
	{
		name: "ticketDetail",
		path: "/:fertigerId/tickets/detail/:id",
		component: TicketDetailComponent,
	},
	{
		name: "production",
		path: "/:fertigerId/production",
		component: ProductionComponent,
	},
	{
		name: "report",
		path: "/:fertigerId/report",
		component: ReportComponent,
	},
	{
		name: "log",
		path: "/:fertigerId/log",
		component: LogComponent,
	},
	{
		name: "leergut",
		path: "/:fertigerId/leergut",
		component: LeergutComponent,
	},
	{
		name: "orderTape",
		path: "/:fertigerId/orderTape",
		component: OrderTapeComponent,
	},
	{
		name: "planning",
		path: "/:fertigerId/planning",
		component: PlanningComponent,
	},
	{
		name: "orderCertificates",
		path: "/:fertigerId/certificates/:orderId",
		component: CertificateComponent,
	},
	{
		name: "offers",
		path: "/:fertigerId/offers",
		component: OffersComponent,
	},
	{
		name: "offer",
		path: "/:fertigerId/offers/:calculationId",
		component: OfferComponent,
	},
];
